<template>
<div class="chapter">
<div class="inner_page">
<p class="SP"> </p>
<p class="Dedication-ded"><span class="ePub-I">This book is—again—for my wife, Anne, my inspiration, collaborator, and first reader.</span></p>
<p class="Dedication-ded"><span class="ePub-I">It is also a nod to the music and musicians that contributed so much to the life of my generation. If you don’t know the songs in this book, I encourage you to download them and listen as you read—there is a playlist at the end.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?932b6ef4